"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));

var _cond = _interopRequireDefault(require("lodash/fp/cond"));

var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));

var _excluded = ["width", "height", "radius", "className"];

var hasChildren = function hasChildren(_ref) {
  var children = _ref.children;
  return !(0, _isNil.default)(children);
};

var renderChildren = function renderChildren(_ref2) {
  var children = _ref2.children;
  return children;
};

var isRect = function isRect(_ref3) {
  var type = _ref3.type;
  return type === ContentLoader.RECT;
};

var isCircle = function isCircle(_ref4) {
  var type = _ref4.type;
  return type === ContentLoader.CIRCLE;
};

var renderRect = function renderRect(_ref5) {
  var _ref5$rx = _ref5.rx,
      rx = _ref5$rx === void 0 ? 3 : _ref5$rx,
      _ref5$ry = _ref5.ry,
      ry = _ref5$ry === void 0 ? 3 : _ref5$ry;
  return /*#__PURE__*/_react.default.createElement("rect", {
    width: '100%',
    height: '100%',
    rx: rx,
    ry: ry
  });
};

var renderCircle = function renderCircle(_ref6) {
  var radius = _ref6.radius;
  return /*#__PURE__*/_react.default.createElement("circle", {
    cx: radius,
    cy: radius,
    r: radius
  });
};

var ContentLoader = function ContentLoader(props) {
  var width = props.width,
      height = props.height,
      radius = props.radius,
      className = props.className,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var content = (0, _cond.default)([[hasChildren, renderChildren], [isRect, renderRect], [isCircle, renderCircle]])(props);
  var wrapperHeight = isCircle(props) ? radius * 2 : height;
  var wrapperWidth = isCircle(props) ? radius * 2 : width;
  return /*#__PURE__*/_react.default.createElement(_reactContentLoader.default, (0, _extends2.default)({
    className: "ContentLoader ".concat(className),
    height: wrapperHeight,
    width: wrapperWidth
  }, remainingProps), content);
};

ContentLoader.RECT = 'rect';
ContentLoader.CIRCLE = 'circle';
ContentLoader.defaultProps = {
  speed: 2,
  height: 14,
  width: '100%',
  radius: 16,
  type: 'rect',
  className: '',
  title: ''
};
ContentLoader.propTypes = {
  speed: _propTypes.default.number,
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  type: _propTypes.default.oneOf(['rect', 'circle', ContentLoader.RECT, ContentLoader.CIRCLE]),
  radius: _propTypes.default.number,
  title: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
var _default = ContentLoader;
exports.default = _default;